// AUTO-GENERATED — DO NOT EDIT. Build with: python scripts/build_yoto_bundle.py
// Source: yoto-card-labels.modules.mjs + yoto-card-labels.entry.js
// Bundled (no dynamic import) so the Alpine component registers synchronously.
(function () {
var M = (function () {
const CURRENT_SCHEMA_VERSION = 1;

const storage = {
  KEY: 'ycl:draft',
  saveDraft(state) {
    try {
      localStorage.setItem(this.KEY, JSON.stringify({ version: CURRENT_SCHEMA_VERSION, payload: state }));
      return true;
    } catch (e) {
      console.warn('[ycl] saveDraft failed', e);
      return false;
    }
  },
  loadDraft() {
    const raw = localStorage.getItem(this.KEY);
    if (!raw) return null;
    try {
      const { version, payload } = JSON.parse(raw);
      if (version !== CURRENT_SCHEMA_VERSION) {
        console.warn('[ycl] unknown draft version', version);
        return null;
      }
      return payload;
    } catch (e) {
      console.warn('[ycl] loadDraft parse failed', e);
      return null;
    }
  },
  clearDraft() { localStorage.removeItem(this.KEY); },
};

function debounce(fn, ms) {
  let t = null;
  return function(...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), ms);
  };
}

// crypto.randomUUID is only defined in secure contexts (HTTPS/localhost). The live
// store is HTTPS, but guard so non-HTTPS previews don't throw and silently break
// every "add label" path.
function uid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'ycl-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}

const CARD_WIDTH_MM = 54.0;
const CARD_HEIGHT_MM = 85.6;
const CARD_ASPECT = CARD_WIDTH_MM / CARD_HEIGHT_MM;
const MAX_FILE_BYTES = 20 * 1024 * 1024;
const JPEG_QUALITY = 0.9;
const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

/**
 * Returns the centred crop rectangle to extract a `targetAspect` (w/h)
 * region from a source image of size srcW × srcH.
 */
function aspectCropRect(srcW, srcH, targetAspect) {
  if (srcW <= 0 || srcH <= 0) {
    throw new Error(`aspectCropRect: dimensions must be positive (got ${srcW}x${srcH})`);
  }
  const srcAspect = srcW / srcH;
  if (srcAspect > targetAspect) {
    const w = srcH * targetAspect;
    return { x: (srcW - w) / 2, y: 0, width: w, height: srcH };
  } else {
    const h = srcW / targetAspect;
    return { x: 0, y: (srcH - h) / 2, width: srcW, height: h };
  }
}

/** Downscale-only fit-into. */
function downscaleDimensions(srcW, srcH, maxW, maxH) {
  if (srcW <= 0 || srcH <= 0) {
    throw new Error(`downscaleDimensions: dimensions must be positive (got ${srcW}x${srcH})`);
  }
  const scale = Math.min(1, maxW / srcW, maxH / srcH);
  return { width: Math.round(srcW * scale), height: Math.round(srcH * scale) };
}

async function processFile(file, opts = {}) {
  // ~300 DPI at card size (54mm wide → 640px) for crisp prints.
  const { maxW = 640, maxH = 1014 } = opts;
  const name = (file.name || '').toLowerCase();
  const looksHeic = /\.(heic|heif)$/.test(name) || file.type === 'image/heic' || file.type === 'image/heif';
  if (looksHeic) {
    throw new Error('iPhone HEIC photos aren’t supported yet. On your iPhone: Settings → Camera → Formats → "Most Compatible", or re-save the photo as JPEG, then try again.');
  }
  if (!file.type || !ALLOWED_IMAGE_TYPES.includes(file.type)) {
    throw new Error(`Unsupported file type${file.type ? ` (${file.type})` : ''}. Please use a JPG, PNG or WebP image.`);
  }
  if (file.size > MAX_FILE_BYTES) {
    throw new Error('That image is too large (max 20MB).');
  }
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((res, rej) => {
      const i = new Image();
      i.onload = () => res(i);
      i.onerror = () => rej(new Error('Could not load that image — it may be corrupted or an unsupported format.'));
      i.src = url;
    });
    if (!img.naturalWidth || !img.naturalHeight) {
      throw new Error('Could not read that image (it may be too large for this device).');
    }
    const crop = aspectCropRect(img.naturalWidth, img.naturalHeight, CARD_ASPECT);
    const dims = downscaleDimensions(crop.width, crop.height, maxW, maxH);
    const canvas = document.createElement('canvas');
    canvas.width = dims.width;
    canvas.height = dims.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      throw new Error('Could not initialise canvas (2d context unavailable).');
    }
    // Fill white first: JPEG has no alpha, so transparent PNG/WebP regions would
    // otherwise composite onto transparent-black and print as solid black.
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, dims.width, dims.height);
    ctx.drawImage(img, crop.x, crop.y, crop.width, crop.height, 0, 0, dims.width, dims.height);
    return canvas.toDataURL('image/jpeg', JPEG_QUALITY);
  } finally {
    URL.revokeObjectURL(url);
  }
}

const MM_PER_PT = 25.4 / 72;
function mmToPt(mm) { return mm / MM_PER_PT; }

const PAPER = {
  A4:     { widthMm: 210,    heightMm: 297    },
  LETTER: { widthMm: 215.9,  heightMm: 279.4  },
};

// 54×85.6mm cards are credit-card sized. On A4 (210×297) and US Letter
// (215.9×279.4) only 3 columns × 3 rows fit — 5 rows would be 428mm tall and
// overflow the page (cards printed off the top / cut off).
const LAYOUT = {
  A4:     { cols: 3, rows: 3 },
  LETTER: { cols: 3, rows: 3 },
};

const SHEET_RESERVED_TOP_MM = 8;
const SHEET_RESERVED_BOTTOM_MM = 8;

function assertKnownPaper(paper) {
  if (!LAYOUT[paper] || !PAPER[paper]) {
    throw new Error(`Unknown paper size: ${paper}. Use one of: ${Object.keys(PAPER).join(', ')}`);
  }
}

function sheetCapacity(paper) {
  assertKnownPaper(paper);
  const { cols, rows } = LAYOUT[paper];
  return cols * rows;
}

function slotRects(paper) {
  assertKnownPaper(paper);
  const { widthMm: pw, heightMm: ph } = PAPER[paper];
  const { cols, rows } = LAYOUT[paper];
  const cw = CARD_WIDTH_MM, ch = CARD_HEIGHT_MM;
  const usableH = ph - SHEET_RESERVED_TOP_MM - SHEET_RESERVED_BOTTOM_MM;
  const totalCardW = cols * cw;
  const totalCardH = rows * ch;
  const gapX = (pw - totalCardW) / (cols + 1);
  const gapY = (usableH - totalCardH) / (rows + 1);
  const rects = [];
  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < cols; c++) {
      rects.push({
        xMm: gapX + c * (cw + gapX),
        yMm: SHEET_RESERVED_TOP_MM + gapY + r * (ch + gapY),
        widthMm: cw,
        heightMm: ch,
      });
    }
  }
  return rects;
}

function paginate(labels, paper) {
  const cap = sheetCapacity(paper);
  const pages = [];
  for (let i = 0; i < labels.length; i += cap) {
    pages.push(labels.slice(i, i + cap));
  }
  return pages.length === 0 ? [[]] : pages;
}

// Lazy-load pdf-lib only when the user first builds a PDF (saves ~513KB on first paint).
// URL is supplied via data-pdflib-url on the script tag in theme.liquid.
let _pdfLibPromise = null;
function ensurePdfLib() {
  if (window.PDFLib) return Promise.resolve();
  if (_pdfLibPromise) return _pdfLibPromise;
  const script = document.querySelector('script[data-pdflib-url]');
  const url = script && script.dataset.pdflibUrl;
  if (!url) return Promise.reject(new Error('pdf-lib URL not configured'));
  _pdfLibPromise = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = url;
    s.onload = () => resolve();
    s.onerror = () => reject(new Error('Failed to load PDF engine'));
    document.head.appendChild(s);
  });
  return _pdfLibPromise;
}

// Kick web-font loads at module init so canvas text renders with the proper face
// rather than silently falling back. Cache is cleared when fonts arrive so existing
// previews repaint on next interaction.
if (typeof document !== 'undefined' && document.fonts) {
  ['Nunito', 'Bebas Neue', 'Caveat'].forEach(f => {
    try { document.fonts.load(`16px "${f}"`); } catch (e) {}
  });
  document.fonts.ready.then(() => { try { _textLabelCache.clear(); } catch (e) {} });
}

const FONTS = {
  sans:        { label: 'Sans',        cssFamily: 'system-ui, -apple-system, sans-serif' },
  serif:       { label: 'Serif',       cssFamily: 'Georgia, "Times New Roman", serif' },
  rounded:     { label: 'Rounded',     cssFamily: '"SF Pro Rounded", "Nunito", sans-serif' },
  mono:        { label: 'Mono',        cssFamily: 'ui-monospace, "SF Mono", Menlo, monospace' },
  display:     { label: 'Display',     cssFamily: '"Bebas Neue", Impact, sans-serif' },
  handwritten: { label: 'Handwritten', cssFamily: '"Caveat", "Comic Sans MS", cursive' },
};

function wrapLines(text, maxWidthPx, measureFn) {
  if (!text) return [];
  const words = text.split(/\s+/).filter(Boolean);
  const lines = [];
  let cur = '';
  for (const word of words) {
    const candidate = cur ? cur + ' ' + word : word;
    if (measureFn(candidate) <= maxWidthPx) {
      cur = candidate;
    } else {
      if (cur) lines.push(cur);
      if (measureFn(word) > maxWidthPx) {
        let chunk = '';
        for (const ch of word) {
          if (measureFn(chunk + ch) <= maxWidthPx) chunk += ch;
          else { lines.push(chunk); chunk = ch; }
        }
        cur = chunk;
      } else {
        cur = word;
      }
    }
  }
  if (cur) lines.push(cur);
  return lines;
}

/**
 * Renders a text label to an offscreen canvas and returns a PNG dataURL.
 * pxPerMm controls render resolution. Use ~12-20 for preview, ~24 for print quality.
 */
// Validate a CSS hex colour; fall back to a default so a bad value (e.g. typed
// into a browser without <input type=color>) never silently blackens the label.
function safeColor(c, fallback) {
  return (typeof c === 'string' && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(c.trim())) ? c.trim() : fallback;
}

const _textLabelCache = new Map();
const _TEXT_CACHE_MAX = 200;

/**
 * Renders a text label to an offscreen canvas and returns a PNG dataURL.
 * Memoised by content so Alpine re-evaluating every preview on each keystroke
 * doesn't re-encode unchanged labels (perf). pxPerMm ~12-20 preview, ~24 print.
 */
function renderTextLabel(label, pxPerMm = 20) {
  const { title = '', subtitle = '', fontKey = 'sans', textColor = '#222', bgColor = '#fff' } = label || {};
  const fg = safeColor(textColor, '#222222');
  const bg = safeColor(bgColor, '#ffffff');
  const key = `${pxPerMm}|${fontKey}|${fg}|${bg}|${title}${subtitle}`;
  const cached = _textLabelCache.get(key);
  if (cached) return cached;

  const wPx = Math.round(CARD_WIDTH_MM * pxPerMm);
  const hPx = Math.round(CARD_HEIGHT_MM * pxPerMm);
  const canvas = document.createElement('canvas');
  canvas.width = wPx;
  canvas.height = hPx;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Could not initialise canvas (2d context unavailable).');
  ctx.fillStyle = bg;
  ctx.fillRect(0, 0, wPx, hPx);
  ctx.fillStyle = fg;
  const family = (FONTS[fontKey] || FONTS.sans).cssFamily;

  const padPx = wPx * 0.08;
  const innerW = wPx - padPx * 2;
  // Cap title to 2 lines when a subtitle is present so the two blocks can't overlap.
  const maxTitleLines = subtitle ? 2 : 3;

  if (title) {
    let titlePx = Math.round(hPx * 0.18);
    ctx.font = `bold ${titlePx}px ${family}`;
    let lines = wrapLines(title, innerW, t => ctx.measureText(t).width);
    while (lines.length > maxTitleLines && titlePx > 10) {
      titlePx -= 2;
      ctx.font = `bold ${titlePx}px ${family}`;
      lines = wrapLines(title, innerW, t => ctx.measureText(t).width);
    }
    lines = lines.slice(0, maxTitleLines);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';
    const blockH = lines.length * titlePx * 1.1;
    const yStart = subtitle ? hPx * 0.12 : (hPx - blockH) / 2;
    lines.forEach((ln, i) => ctx.fillText(ln, wPx / 2, yStart + i * titlePx * 1.1));
  }

  if (subtitle) {
    let subPx = Math.round(hPx * 0.10);
    ctx.font = `${subPx}px ${family}`;
    let lines = wrapLines(subtitle, innerW, t => ctx.measureText(t).width);
    while (lines.length > 2 && subPx > 8) {
      subPx -= 1;
      ctx.font = `${subPx}px ${family}`;
      lines = wrapLines(subtitle, innerW, t => ctx.measureText(t).width);
    }
    lines = lines.slice(0, 2);
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';
    const blockH = lines.length * subPx * 1.1;
    const yStart = hPx * 0.88 - blockH;
    lines.forEach((ln, i) => ctx.fillText(ln, wPx / 2, yStart + (i + 1) * subPx * 1.1));
  }

  const out = canvas.toDataURL('image/png');
  if (_textLabelCache.size >= _TEXT_CACHE_MAX) _textLabelCache.clear();
  _textLabelCache.set(key, out);
  return out;
}

async function buildPdf(state) {
  await ensurePdfLib();
  const { PDFDocument, PDFName, rgb, StandardFonts } = window.PDFLib;
  const { paperSize, labels, showCutLines, fullBleed } = state;
  const paper = PAPER[paperSize];
  const slots = slotRects(paperSize);
  const pages = paginate(labels, paperSize);

  // Clamp full-bleed so it never exceeds half the gap, else images overlap the
  // neighbouring card / cut line (Letter's vertical gap is only ~1.65mm).
  const cols = new Set(slots.map(s => s.xMm.toFixed(3))).size;
  const gapXmm = slots.length > 1 ? slots[1].xMm - (slots[0].xMm + slots[0].widthMm) : 8;
  const gapYmm = slots.length > cols ? slots[cols].yMm - (slots[0].yMm + slots[0].heightMm) : 8;
  const bleedMm = fullBleed ? Math.max(0, Math.min(1, gapXmm / 2, gapYmm / 2)) : 0;

  const pdf = await PDFDocument.create();
  // Tell PDF viewers (esp. Adobe Reader, default = "Shrink Oversized Pages") to print at actual size.
  pdf.catalog.set(PDFName.of('ViewerPreferences'), pdf.context.obj({ PrintScaling: PDFName.of('None') }));
  const helv = await pdf.embedFont(StandardFonts.Helvetica);
  const totalPages = pages.length;
  const embedCache = new Map(); // embed identical images once (duplicate-to-fill-sheet clones)
  async function embed(dataUrl) {
    let img = embedCache.get(dataUrl);
    if (img) return img;
    const bytes = dataUrlToBytes(dataUrl);
    img = dataUrl.startsWith('data:image/png') ? await pdf.embedPng(bytes) : await pdf.embedJpg(bytes);
    embedCache.set(dataUrl, img);
    return img;
  }

  for (let p = 0; p < pages.length; p++) {
    const page = pdf.addPage([mmToPt(paper.widthMm), mmToPt(paper.heightMm)]);
    const pageH = page.getHeight();

    if (totalPages > 1) {
      page.drawText(`Sheet ${p + 1} of ${totalPages}`, {
        x: mmToPt(8), y: pageH - mmToPt(5), size: 7, font: helv, color: rgb(0.5, 0.5, 0.5),
      });
    }

    page.drawText('Made with Printforge — printforge.com.au/pages/yoto-card-labels', {
      x: mmToPt(8), y: mmToPt(3), size: 6, font: helv, color: rgb(0.5, 0.5, 0.5),
    });

    const labelsThisPage = pages[p];
    for (let i = 0; i < labelsThisPage.length; i++) {
      const slot = slots[i];
      const label = labelsThisPage[i];
      const slotX = mmToPt(slot.xMm);
      const slotY = pageH - mmToPt(slot.yMm + slot.heightMm);
      const slotW = mmToPt(slot.widthMm);
      const slotH = mmToPt(slot.heightMm);

      let dataUrl = null;
      if (label.type === 'image' && label.imageDataUrl) {
        dataUrl = label.imageDataUrl;
      } else if (label.type === 'text' || label.type === 'template') {
        dataUrl = renderTextLabel(label, 24);
      }

      if (dataUrl) {
        const img = await embed(dataUrl);
        page.drawImage(img, {
          x: slotX - mmToPt(bleedMm),
          y: slotY - mmToPt(bleedMm),
          width: slotW + mmToPt(bleedMm * 2),
          height: slotH + mmToPt(bleedMm * 2),
        });
      }

      if (showCutLines) {
        page.drawRectangle({
          x: slotX, y: slotY, width: slotW, height: slotH,
          borderColor: rgb(0.6, 0.6, 0.6), borderWidth: 0.25,
        });
      }
    }
  }

  const bytes = await pdf.save();
  return new Blob([bytes], { type: 'application/pdf' });
}

async function buildCalibrationPdf(paperSize) {
  assertKnownPaper(paperSize);
  await ensurePdfLib();
  const { PDFDocument, PDFName, rgb, StandardFonts } = window.PDFLib;
  const paper = PAPER[paperSize];
  const pdf = await PDFDocument.create();
  pdf.catalog.set(PDFName.of('ViewerPreferences'), pdf.context.obj({ PrintScaling: PDFName.of('None') }));
  const helv = await pdf.embedFont(StandardFonts.Helvetica);
  const page = pdf.addPage([mmToPt(paper.widthMm), mmToPt(paper.heightMm)]);
  const pageW = page.getWidth();
  const pageH = page.getHeight();

  // Corner registration squares (10mm), inset 5mm so printers' unprintable
  // edge margin doesn't clip them.
  const sz = mmToPt(10);
  const ins = mmToPt(5);
  const cornerOffsets = [
    [ins, ins], [pageW - sz - ins, ins], [ins, pageH - sz - ins], [pageW - sz - ins, pageH - sz - ins],
  ];
  for (const [x, y] of cornerOffsets) {
    page.drawRectangle({ x, y, width: sz, height: sz, borderColor: rgb(0,0,0), borderWidth: 1 });
  }

  // 100mm horizontal ruler near top
  const rulerY = pageH - mmToPt(20);
  page.drawLine({ start: { x: mmToPt(20), y: rulerY }, end: { x: mmToPt(120), y: rulerY }, thickness: 0.5, color: rgb(0,0,0) });
  for (let mm = 0; mm <= 100; mm += 10) {
    const x = mmToPt(20 + mm);
    page.drawLine({ start: { x, y: rulerY - mmToPt(1) }, end: { x, y: rulerY + mmToPt(1) }, thickness: 0.5, color: rgb(0,0,0) });
    page.drawText(`${mm}`, { x: x - 3, y: rulerY + 4, size: 6, font: helv, color: rgb(0,0,0) });
  }

  // Single test card outline, centred on the page
  const slotX = (pageW - mmToPt(CARD_WIDTH_MM)) / 2;
  const slotY = (pageH - mmToPt(CARD_HEIGHT_MM)) / 2;
  page.drawRectangle({
    x: slotX, y: slotY,
    width: mmToPt(CARD_WIDTH_MM), height: mmToPt(CARD_HEIGHT_MM),
    borderColor: rgb(0,0,0), borderWidth: 0.5,
  });
  page.drawText('CARD: 54.0 x 85.6mm', { x: slotX + 4, y: slotY + 4, size: 8, font: helv });

  page.drawText(`Calibration page - ${paperSize} - Set print scaling to 100% / Actual Size.`, {
    x: mmToPt(20), y: mmToPt(8), size: 9, font: helv,
  });

  const bytes = await pdf.save();
  return new Blob([bytes], { type: 'application/pdf' });
}

function dataUrlToBytes(dataUrl) {
  return Uint8Array.from(atob(dataUrl.split(',')[1]), c => c.charCodeAt(0));
}

function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const ua = navigator.userAgent || '';
  const isIOS = /iP(hone|ad|od)/.test(ua) ||
    (ua.includes('Macintosh') && typeof document !== 'undefined' && 'ontouchend' in document);
  if (isIOS) {
    // iOS Safari ignores the download attribute; open the PDF so the user can
    // use Share → Save to Files / Print.
    window.open(url, '_blank');
  } else {
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  // Defer revoke so Safari has time to load/save the blob.
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

return { CURRENT_SCHEMA_VERSION, storage, debounce, uid, CARD_WIDTH_MM, CARD_HEIGHT_MM, CARD_ASPECT, MAX_FILE_BYTES, JPEG_QUALITY, ALLOWED_IMAGE_TYPES, aspectCropRect, downscaleDimensions, processFile, MM_PER_PT, mmToPt, PAPER, SHEET_RESERVED_TOP_MM, SHEET_RESERVED_BOTTOM_MM, sheetCapacity, slotRects, paginate, ensurePdfLib, FONTS, wrapLines, safeColor, renderTextLabel, buildPdf, buildCalibrationPdf, downloadBlob };
})();

// yoto-card-labels.entry.js — app logic for the Yoto Card Label Maker.
//
// SOURCE file. Bundled with yoto-card-labels.modules.mjs into the deployed
// yoto-card-labels.js by scripts/build_yoto_bundle.py — do NOT reference directly.
// `M` is the module namespace. Bundled (not dynamically imported) and loaded
// before Alpine so the component registers synchronously, before Alpine starts.
(function () {
  function register() {
    window.Alpine.data('yclApp', () => ({
      paperSize: 'A4',
      showCutLines: true,
      fullBleed: false,        // off by default: fixed-size cards aren't trimmed past the cut line
      labels: [],
      selectedLabelId: null,
      isBusy: false,
      templates: [],
      templatesFailed: false,
      showTemplatePicker: false,
      dragSourceId: null,
      saveError: false,
      justDownloaded: false,
      liveMsg: '',          // visually-hidden aria-live announcer
      uiError: '',          // inline error banner (replaces alert)
      confirmingClear: false, // inline Start-over confirmation (replaces confirm)
      announce(msg) { this.liveMsg = ''; setTimeout(() => { this.liveMsg = msg; }, 50); },

      onDragStart(id, e) { this.dragSourceId = id; e.dataTransfer.effectAllowed = 'move'; },
      onDragOver(e) { e.preventDefault(); e.dataTransfer.dropEffect = 'move'; },
      onDrop(targetId) {
        if (!this.dragSourceId || this.dragSourceId === targetId) return;
        const from = this.labels.findIndex(l => l.id === this.dragSourceId);
        const to = this.labels.findIndex(l => l.id === targetId);
        if (from === -1 || to === -1) return;
        const [moved] = this.labels.splice(from, 1);
        this.labels.splice(to, 0, moved);
        this.dragSourceId = null;
      },

      // Touch- and keyboard-friendly reorder (HTML5 drag doesn't fire on touch).
      moveLabel(id, delta) {
        const from = this.labels.findIndex(l => l.id === id);
        if (from === -1) return;
        const to = from + delta;
        if (to < 0 || to >= this.labels.length) return;
        const [moved] = this.labels.splice(from, 1);
        this.labels.splice(to, 0, moved);
        this.selectedLabelId = id;
      },

      duplicateToFillSheet(id) {
        const src = this.labels.find(l => l.id === id);
        if (!src) return;
        const idx = this.labels.indexOf(src);
        const cap = this.capacity;
        const sheetStart = Math.floor(idx / cap) * cap;
        const slotInSheet = idx - sheetStart;
        const remaining = cap - slotInSheet - 1;
        if (remaining <= 0) return;
        // labels are flat objects; a shallow spread clone avoids re-serialising
        // the (large) base64 image string per clone.
        const clones = Array.from({ length: remaining }, () => ({ ...src, id: M.uid() }));
        this.labels.splice(idx + 1, 0, ...clones);
      },

      // A11y: contain Tab inside the template-picker modal (background is visually
      // inert but still in the tab order) and restore focus to the opener on close.
      pickerOpener: null,
      trapModalTab(e) {
        const root = this.$refs.modalContent;
        if (!root) return;
        const f = root.querySelectorAll('button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === root)) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      },

      init() {
        this.$watch('showTemplatePicker', (open) => {
          if (open) {
            this.pickerOpener = document.activeElement;
          } else if (this.pickerOpener && typeof this.pickerOpener.focus === 'function') {
            this.pickerOpener.focus();
            this.pickerOpener = null;
          }
        });
        const draft = M.storage.loadDraft();
        if (draft) {
          Object.assign(this, draft);
          // Images aren't persisted (too large for localStorage) — drop placeholders.
          this.labels = (this.labels || []).filter(l => !(l.type === 'image' && !l.imageDataUrl));
        } else {
          this.paperSize = this.$el.dataset.paperDefault || 'A4';
        }
        // Persist only the saved fields; don't deep-watch transient UI state.
        const save = M.debounce(() => this.saveDraft(), 500);
        this.$watch('labels', save, { deep: true });
        this.$watch('paperSize', save);
        this.$watch('showCutLines', save);
        this.$watch('fullBleed', save);
        fetch(this.$el.dataset.templatesUrl)
          .then(r => r.ok ? r.json() : Promise.reject(new Error('HTTP ' + r.status)))
          .then(j => { this.templates = j; })
          .catch(e => { this.templatesFailed = true; console.warn('[ycl] templates failed to load', e); });
      },

      applyTemplate(t) {
        const id = M.uid();
        this.labels.push({
          id, type: 'template', templateId: t.id,
          title: t.name || '', subtitle: '',
          fontKey: t.fontKey, textColor: t.textColor, bgColor: t.bgColor,
        });
        this.selectedLabelId = id;
        this.showTemplatePicker = false;
      },

      saveDraft() {
        // Don't persist base64 image data (blows the ~5MB localStorage quota and
        // kills all autosave). Text/template labels persist fully.
        const ok = M.storage.saveDraft({
          paperSize: this.paperSize,
          showCutLines: this.showCutLines,
          fullBleed: this.fullBleed,
          labels: this.labels.map(l => l.type === 'image' ? { ...l, imageDataUrl: null } : l),
        });
        this.saveError = !ok;
      },

      clearAll() {
        // Inline confirmation handled by template's `confirmingClear` flow.
        this.labels = [];
        this.selectedLabelId = null;
        this.justDownloaded = false;
        this.uiError = '';
        M.storage.clearDraft();
        this.announce('All cards removed.');
      },

      get capacity() { return M.sheetCapacity(this.paperSize); },
      get pages() { return M.paginate(this.labels, this.paperSize); },
      get slots() { return M.slotRects(this.paperSize); },

      async addImageFiles(fileList) {
        this.isBusy = true;
        const skipped = [];
        try {
          for (const f of Array.from(fileList)) {
            try {
              const dataUrl = await M.processFile(f);
              this.labels.push({
                id: M.uid(),
                type: 'image',
                imageDataUrl: dataUrl,
                imageOriginalName: f.name,
                rotation: 0,
              });
            } catch (e) {
              skipped.push(`• ${f.name} — ${e.message}`);
            }
          }
        } finally {
          this.isBusy = false;
        }
        if (skipped.length) {
          this.uiError = `Couldn't add ${skipped.length} file${skipped.length > 1 ? 's' : ''}: ${skipped.join('  ')}`;
          this.announce(this.uiError);
        }
      },

      removeLabel(id) {
        this.labels = this.labels.filter(l => l.id !== id);
        if (this.selectedLabelId === id) this.selectedLabelId = null;
      },

      addTextLabel() {
        const id = M.uid();
        this.labels.push({
          id, type: 'text', title: '', subtitle: '',
          fontKey: 'sans', textColor: '#222222', bgColor: '#ffffff',
        });
        this.selectedLabelId = id;
      },

      get selectedLabel() {
        return this.labels.find(l => l.id === this.selectedLabelId) || null;
      },

      renderTextPreview(label) {
        return M.renderTextLabel(label, 12);
      },

      async download() {
        this.isBusy = true;
        this.uiError = '';
        this.announce('Building your PDF…');
        try {
          const blob = await M.buildPdf({
            paperSize: this.paperSize,
            showCutLines: this.showCutLines,
            fullBleed: this.fullBleed,
            labels: this.labels,
          });
          const date = new Date().toISOString().slice(0, 10);
          M.downloadBlob(blob, `yoto-cards-${date}.pdf`);
          this.justDownloaded = true;
          this.announce('PDF ready — check your Downloads folder.');
        } catch (e) {
          this.uiError = "Sorry — we couldn't build your PDF. Try removing the last card you added and retry.";
          this.announce(this.uiError);
          console.error(e);
        } finally {
          this.isBusy = false;
        }
      },

      async downloadCalibration() {
        this.isBusy = true;
        this.uiError = '';
        this.announce('Building print test page…');
        try {
          const blob = await M.buildCalibrationPdf(this.paperSize);
          M.downloadBlob(blob, `yoto-cards-print-size-test-${this.paperSize}.pdf`);
          this.announce('Print test page ready.');
        } catch (e) {
          this.uiError = "Sorry — we couldn't create the print-size test page. Please try again.";
          this.announce(this.uiError);
          console.error(e);
        } finally {
          this.isBusy = false;
        }
      },
    }));
  }

  if (window.Alpine && window.Alpine.version) {
    register();
    if (window.Alpine.initTree) window.Alpine.initTree(document.getElementById('ycl-app'));
  } else {
    document.addEventListener('alpine:init', register);
  }
})();

})();
